export const CHATGPT_GUIDE = `Create a complete, self-contained educational simulation for the AutoMeetNetwork website as ONE HTML file.

1) FILE
- Start with <!doctype html> and end with </html>. All CSS in <style>, all JS in <script>.
- The scene must fill 100% of the window (html, body { margin:0; height:100%; overflow:hidden }) and scale responsively
  WITHOUT cropping (SVG viewBox + preserveAspectRatio="xMidYMid meet", or a canvas that resizes on window resize). Design for 16:9.
- Mouse AND touch (pointer events), big clear controls, Arabic labels, beginner friendly.
- No timers/countdowns, no forms, popups, alerts, network requests or localStorage.
- External libraries ONLY from https://cdn.jsdelivr.net, https://unpkg.com, https://cdnjs.cloudflare.com, https://esm.sh
  (e.g. Three.js: https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js). Images only inline SVG or data: URLs.

2) EDUCATIONAL DATA (required) — put this inside <head>. Data only, no code. correctAnswer starts at 0.
<script type="application/json" id="am-simulation-data">
{
  "schemaVersion": 1,
  "title": "Arabic title",
  "description": "Short Arabic description (max 1000 chars)",
  "category": "PLC | التحكم بالمحركات | الحساسات | الدارات الكهربائية | الأنظمة الصناعية",
  "level": "beginner | intermediate | advanced",
  "renderMode": "2d | 3d",
  "objective": "What the learner will understand",
  "instructions": ["step 1", "step 2", "step 3"],
  "explanation": "How the system works / operating sequence",
  "diagram": ["Start button (NO) -> I0.0", "Q0.0 -> KM1 coil -> motor"],
  "extraInfo": "Optional extra notes",
  "actions": ["start-sequence", "stop-sequence"],
  "questions": [
    { "id": "q1", "question": "...", "options": ["A", "B", "C", "D"], "correctAnswer": 1,
      "explanation": "Simple explanation", "simulationAction": "start-sequence" }
  ]
}
</script>
- Up to 50 questions, 4 options each for multiple choice ("options": [] for an open question).
- Every simulationAction must be listed in "actions" and implemented in the scene. Names: lowercase letters, digits, "-" only.

3) EMBED MODE
The website shows the title, description, instructions, questions and explanations itself.
If your file also shows its own title/instructions/questions panel (useful when opened alone), mark those elements with
the attribute data-am-site-ui — they are hidden automatically inside the website. The interactive scene and its own
control buttons must NOT have this attribute. You can also check window.AMN_EMBED === true.

4) WEBSITE BRIDGE — the site injects window.AMN before your script. Always guard it:
  const AMN = window.AMN || { on(){}, ready(){}, metrics(){}, state(){}, result(){} };
  AMN.on('start', () => {...});  AMN.on('stop', () => {...});  AMN.on('reset', () => {...});
  AMN.on('goto', ({ step }) => {...});                 // jump to a situation
  AMN.on('showAnswer', ({ questionId, action }) => {...});  // play the animation for that action
  AMN.on('answer', ({ questionId, choice, correct }) => {...});  // optional
  AMN.ready({ supports: ['start','stop','reset','goto','showAnswer'], actions: ['start-sequence','stop-sequence'] });
  AMN.metrics([{ label: 'حالة المحرك', value: 'يعمل', tone: 'green' }]);  // up to 6 boxes; tone: green|red|blue|amber|gray
  AMN.result({ event: 'motor_started' });  // optional
The file must also work normally when window.AMN is missing (opened directly in a browser).

Simulation topic: <describe the simulation here>`;
